import React, { useContext } from 'react';
import { Avatar, Box, Dialog, DialogTitle, Grid, Stack, Typography } from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import { RxCross2 } from 'react-icons/rx';
import { MdOutlineModeEdit } from 'react-icons/md';
import { LanguageContext } from '../../../../../../../libs/Context';

const SpeakerDetailsPopup = (props) =>
{
	const { language } = useContext(LanguageContext);
	const { open, details, setOpen, handleAddSpeaker } = props;
	const { linkedinUrl, twitterUrl } = details;

	const handleClose = () =>
	{
		setOpen(false);
	};

	return (

		<Dialog
			open={open}
			fullWidth
			maxWidth='md'
		>
			<DialogTitle>
				<Grid container spacing={2} justifyContent='space-between' direction='row'>
					<Grid item>
						<Typography variant='h6'>
							{language?.details}
						</Typography>
					</Grid>
					<Grid item>
						<Box display={'flex'} gap='var(--pixel8)'>
							<Typography pr='var(--pixel16)' variant='inherit' onClick={(e) => { handleAddSpeaker(e, details); handleClose(); }} sx={{ cursor: 'pointer' }}>
								<MdOutlineModeEdit fontSize='var(--pixel20)'/>
							</Typography>
							<Typography variant='inherit' onClick={handleClose} sx={{ cursor: 'pointer' }}>
								<RxCross2 fontSize='var(--pixel20)'/>
							</Typography>
						</Box>
					</Grid>
				</Grid>
			</DialogTitle>
			<DialogContent>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<Box display={'flex'} flexDirection={'column'} alignItems={'center'} justifyContent={'center'} gap={2}>
							<Avatar
								alt='Profile'
								src={details.speakerImage?.url}
								sx={{ width: 96, height: 96 }}
							/>
							<Stack direction={'row'} spacing={2}>
								{linkedinUrl && <Avatar alt='Linkedin' src='/images/logos/webLink.svg' variant='rounded' sx={{ width: 28, height: 28 }} />}
								{<Avatar alt='Instagram' src='/images/logos/webInsta.svg' variant='rounded' sx={{ width: 28, height: 28 }} />}
								{twitterUrl && <Avatar alt='Twitter' src='/images/logos/webTwitt.svg' variant='rounded' sx={{ width: 28, height: 28 }} />}
							</Stack>
						</Box>
					</Grid>
					<Grid item xs={12} >
						<Grid container p='var(--pixel8)'>
							<Grid item xs={12} sm={6} p='var(--pixel8)'>
								<Stack
									direction='column'
									sx={{ borderBottom: '1px solid #CFD1D4', maxHeight: '70px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
								>
									<Typography variant='subtitle2'>{language?.name}</Typography>
									<Typography sx={{ padding: 'var(--pixel10)' }} variant='body2' >{details?.speakerName}</Typography>
								</Stack>
							</Grid>
							<Grid item xs={12} sm={6} p='var(--pixel8)'>
								<Stack
									direction='column'
									sx={{ borderBottom: '1px solid #CFD1D4', maxHeight: '70px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
								>
									<Typography variant='subtitle2'>{language?.emailID }</Typography>
									<Typography sx={{ padding: 'var(--pixel10)' }} variant='body2' >{details?.speakerEmail}</Typography>
								</Stack>
							</Grid>
						</Grid>
						<Grid container p='var(--pixel8)'>
							<Grid item xs={12} sm={6} p='var(--pixel8)'>
								<Stack
									direction='column'
									sx={{ borderBottom: '1px solid #CFD1D4', maxHeight: '70px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
								>
									<Typography variant='subtitle2'>{language?.designation}</Typography>
									<Typography sx={{ padding: 'var(--pixel10)' }} variant='body2' >{details?.designation ?? '---'}</Typography>
								</Stack>
							</Grid>
							<Grid item xs={12} sm={6} p='var(--pixel8)'>
								<Stack
									direction='column'
									sx={{ borderBottom: '1px solid #CFD1D4', maxHeight: '70px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
								>
									<Typography variant='subtitle2'>{language?.organization}</Typography>
									<Typography sx={{ padding: 'var(--pixel10)' }} variant='body2' >{details?.organization ?? '---'}</Typography>
								</Stack>
							</Grid>
						</Grid>
						<Grid item xs={12} display={'flex'} flexDirection={'column'} p='var(--pixel16)'>
							<Typography variant='subtitle2' pb='var(--pixel8)'>{language?.description}</Typography>
							<Box sx={{ background: '#EEEEEE', width: 'var(--percent100)', minHeight: '86px', borderRadius: 'var(--pixel8)' }} p='var(--pixel8)'>
								<Typography variant='body2'>{details?.description ?? '---'}</Typography></Box>
						</Grid>
					</Grid>
				</Grid>
			</DialogContent>
		</Dialog>

	);
};

export default SpeakerDetailsPopup;